let html = document.documentElement;
let body = document.body;
let lastMonth;
let lastGroup;
let timeout;
let st = 0;
let rtPost = 0;
let members_list = []
let nextId;
let prevId;


cover();
featured();
archive();
video();
gallery();
table();
burger();

window.addEventListener('scroll', function () {
    'use strict';
    if (body.classList.contains('home-template') && body.classList.contains('with-full-cover')) {
        if (timeout) {
            window.cancelAnimationFrame(timeout);
        }
        timeout = window.requestAnimationFrame(portalButton);
    }
});

function portalButton() {
    'use strict';
    st = window.scrollY;

    if (st > 300) {
        body.classList.add('portal-visible');
    } else {
        body.classList.remove('portal-visible');
    }
}

function cover() {
    'use strict';
    var cover = document.querySelector('.cover');
    if (!cover) return;

    imagesLoaded(cover, function () {
        cover.classList.remove('image-loading');
    });
}

function featured() {
    'use strict';
    var feed = document.querySelector('.featured-feed');
    if (!feed) return;

    tns({
        container: feed,
        controlsText: [
            '<svg class="icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32"><path d="M20.547 22.107L14.44 16l6.107-6.12L18.667 8l-8 8 8 8 1.88-1.893z"></path></svg>',
            '<svg class="icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32"><path d="M11.453 22.107L17.56 16l-6.107-6.12L13.333 8l8 8-8 8-1.88-1.893z"></path></svg>',
        ],
        gutter: 30,
        loop: false,
        nav: false,
        responsive: {
            0: {
                items: 1,
            },
            768: {
                items: 2,
            },
            992: {
                items: 3,
            },
        },
    });
}

function archive(data) {
    'use strict';
    if (!body.classList.contains('logged-in')) return;

    var posts = data || document.querySelectorAll('.feed');

    posts.forEach(function (post) {
        var current = post.getAttribute('data-month');
        if (current != lastMonth) {
            var month = document.createElement('div');
            month.className = 'feed-month';
            month.innerText = current;

            var group = document.createElement('div');
            group.className = 'feed-group';
            group.appendChild(month);

            feed.insertBefore(group, post);

            group.appendChild(post);

            lastMonth = current;
            lastGroup = group;
        } else {
            lastGroup.appendChild(post);
        }
    });
}

function video() {
    'use strict';
    const sources = [
        '.single-content iframe[src*="youtube.com"]',
        '.single-content iframe[src*="youtube-nocookie.com"]',
        '.single-content iframe[src*="player.vimeo.com"]',
        '.single-content iframe[src*="kickstarter.com"][src*="video.html"]',
        'object',
        'embed',
    ];

    reframe(document.querySelectorAll(sources.join(',')));
}

function gallery() {
    'use strict';
    var images = document.querySelectorAll('.kg-gallery-image img');
    images.forEach(function (image) {
        var container = image.closest('.kg-gallery-image');
        var width = image.attributes.width.value;
        var height = image.attributes.height.value;
        var ratio = width / height;
        container.style.flex = ratio + ' 1 0%';
    });

    pswp(
        '.kg-gallery-container',
        '.kg-gallery-image',
        '.kg-gallery-image',
        false,
        true
    );
}

function table() {
    'use strict';
    if (!body.classList.contains('post-template') && !body.classList.contains('page-template')) return;

    var tables = document.querySelectorAll('.single-content .table');

    tables.forEach(function (table) {
        var labels = [];

        table.querySelectorAll('thead th').forEach(function (label) {
            labels.push(label.textContent);
        });

        table.querySelectorAll('tr').forEach(function (row) {
            row.querySelectorAll('td').forEach(function (column, index) {
                column.setAttribute('data-label', labels[index]);
            });
        });
    });
}

function burger() {
    'use strict';
    const burger = document.querySelector('.rt-burger');
    if (burger) {
        burger.addEventListener('click', function () {
            if (!body.classList.contains('menu-opened')) {
                body.classList.add('menu-opened');
                selectFirstMainMenu();
            } else {
                body.classList.remove('menu-opened');
            }
        });
    }
   
}

function pswp(container, element, trigger, caption, isGallery) {
    var parseThumbnailElements = function (el) {
        var items = [],
            gridEl,
            linkEl,
            item;

        el
            .querySelectorAll(element)
            .forEach(function (v) {
                gridEl = v;
                linkEl = gridEl.querySelector(trigger);

                item = {
                    src: isGallery
                        ? gridEl.querySelector('img').getAttribute('src')
                        : linkEl.getAttribute('href'),
                    w: 0,
                    h: 0,
                };

                if (caption && gridEl.querySelector(caption)) {
                    item.title = gridEl.querySelector(caption).innerHTML;
                }

                items.push(item);
            });

        return items;
    };

    var openPhotoSwipe = function (index, galleryElement) {
        var pswpElement = document.querySelectorAll('.pswp')[0],
            gallery,
            options,
            items;

        items = parseThumbnailElements(galleryElement);

        options = {
            closeOnScroll: false,
            history: false,
            index: index,
            shareEl: false,
            showAnimationDuration: 0,
            showHideOpacity: true,
        };

        gallery = new PhotoSwipe(
            pswpElement,
            PhotoSwipeUI_Default,
            items,
            options
        );
        gallery.listen('gettingData', function (index, item) {
            if (item.w < 1 || item.h < 1) {
                // unknown size
                var img = new Image();
                img.onload = function () {
                    // will get size after load
                    item.w = this.width; // set image width
                    item.h = this.height; // set image height
                    gallery.updateSize(true); // reinit Items
                };
                img.src = item.src; // let's download image
            }
        });
        gallery.init();
    };

    var onThumbnailsClick = function (e) {
        e.preventDefault();

        var siblings = e.target.closest(container).querySelectorAll(element);
        var nodes = Array.prototype.slice.call(siblings);
        var index = nodes.indexOf(e.target.closest(element));
        var clickedGallery = e.target.closest(container);

        openPhotoSwipe(index, clickedGallery);

        return false;
    };

    // container = document.querySelector(container);
    // if (!container) return;

    var triggers = document.querySelectorAll(trigger);
    triggers.forEach(function (trig) {
        trig.addEventListener('click', function (e) {
            onThumbnailsClick(e);
        });
    });
}

// document.querySelector("#skip").addEventListener('click', function (e) {
//     document.querySelector("#main").scrollIntoView({
//         behavior: 'smooth'
//     });
//     document.querySelector(this.getAttribute('href')).focus();
//     window.location.hash = "main"
// });

// if (document.location.hash) {
//     var myAnchor = document.location.hash;
//     $(myAnchor).attr('tabindex', -1).on('blur focusout', function () {
//         $(this).removeAttr('tabindex');
//     }).focus().yellowFade();
// }

jQuery(window).bind('hashchange', function() {
    var hash = "#"+window.location.hash.replace(/^#/,'');
    if (hash!="#") {
        jQuery(hash).attr('tabindex', -1).on('blur focusout', function () {
            jQuery(this).removeAttr('tabindex');
        }).focus().yellowFade();
    }
    else {
        jQuery("#main").attr('tabindex', -1).on('blur focusout', function () {
            jQuery(this).removeAttr('tabindex');
        }).focus();
    }
});


function getMembers() {
    if(!$("#rt-members-section")) {
        return;
    }
    fetch('/ghost/api/content/authors/?limit=100&limit=100&key=' + config['content-api-key'])
        .then((response) => response.json())
        .then((data) => {
            const currentLocation = getCurrentLocations();
            if (data?.authors) {
                let members = data?.authors.filter(m => currentLocation.includes(m.location)).sort(() => Math.random() - 0.5);
                // let members =  Array(17).fill(data?.authors[0]);
                members_list = members;
                handleMembers(members);
            }
        });
}

function getCurrentLocations() {
    const path = window.location.pathname;
    if (path.includes("warszawa")) {
        return ['Warszawa'];
    } else if(path.includes("olsztyn")) {
        return ['Olsztyn'];
    } else if(path.includes("wroclaw")) {
        return ["Wrocław"];
    } else {
        return ['Warszawa', 'Olsztyn', "Wrocław"];
    }
}

function handleMembers(members) {
    const chunkSize = 8;
    for (let i = 0; i < members.length; i += chunkSize) {
        const chunk = members.slice(i, i + chunkSize);
        const container = jQuery('<div>', {
            class: 'rt-members-container',
        })
        drawMembers(chunk, container)
        container.appendTo("#rt-members-section")
    }
    document.querySelectorAll('a[class^="rt-member"]').forEach(anchor => {
        anchor.addEventListener('click', function (e) {
            e.preventDefault();
        });
    });
   
}

function drawMembers(members, container) {
    if(container) {
        members.forEach((member, index) => {
            container.append(
                '<a role="button" class="rt-member rt-member-' + index + '" href="#" onclick="openMemberModal(\'' + member.id + '\')"> ' +
                '   <img class="rt-member-image" src="' + member.profile_image +  '" alt=""/>' +
                '   <div class="rt-member-click"><span>O mnie</span>'+
                '   </div>' +
                '   <div class="rt-member-info">' +
                '       <div class="rt-member-name"> ' + member.name + '</div>' +
                '       <div class="rt-member-location-chip"> ' +
                '           <div class="rt-member-location"> ' + member.location + '</div>' +
                '       </div>' +
                '   </div>' +
                '</a>'
            );
        })
        switch (members.length) {
            case 1: 
            case 2: 
                container[0].style.gridTemplateRows="85px 217px 302px"; break;
            case 3: 
            case 4: 
                container[0].style.gridTemplateRows="85px 217px 302px 109px 85px"; break;
            case 5: 
                container[0].style.gridTemplateRows="85px 217px 302px 109px 217px 85px"; break;
            case 6: 
                container[0].style.gridTemplateRows="85px 217px 302px 109px 217px 85px 85px"; break;
            case 7: 
            case 8: 
                container[0].style.gridTemplateRows="85px 217px 302px 109px 217px 85px 217px"; break;
        }
    }
}

function openMemberModal(id) {
    let member;
    for (let index = 0; index < members_list.length; index++) {
        const element = members_list[index];
        if(element.id == id) {
            member = element;
            if (index === 0) {
                nextId = members_list[index + 1].id;
                prevId = members_list[members_list.length - 1].id
            } else if((index + 1) === members_list.length) {
                nextId = members_list[0].id;
                prevId = members_list[index - 1].id
            } else {
                nextId = members_list[index + 1].id;
                prevId = members_list[index - 1].id
            }
            break;
        }
    }
    if(member) {
        jQuery("#rt-member-modal-photo-img").attr("src", member.profile_image);
        jQuery("#rt-member-location-chip").text(member.location);
        jQuery("#rt-member-modal-name").text(member.name);
        jQuery("#rt-member-modal-bio").text(member.bio);
        jQuery("#rt-member-modal-photo-img").attr("src", member.profile_image);
        // jQuery('#rt-member-details-modal').show()
        document.getElementById("rt-member-details-modal").showModal();
    }
   
}

function rtNextMember() {
    openMemberModal(nextId);
}

function rtPrevMember() {
    openMemberModal(prevId);
}

function closeMemberDialog() {
    document.getElementById("rt-member-details-modal").close();
    // jQuery('#rt-member-details-modal').hide();
}

jQuery(function($) {
    getMembers();
});

